var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBase24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C14.3734 24 16.6934 23.2962 18.6668 21.9776C20.6402 20.659 22.1783 18.785 23.0866 16.5922C23.9948 14.3995 24.2324 11.9867 23.7695 9.65895C23.3064 7.33115 22.1635 5.19295 20.4853 3.51472C18.8071 1.83649 16.6688 0.693605 14.3411 0.230582C12.0133 -0.232441 9.60052 0.00519955 7.40779 0.913448C5.21509 1.82171 3.34094 3.35977 2.02237 5.33316C0.703788 7.30655 0 9.62663 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76515 22.7357 8.81737 24 12 24Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9718 20.4507C16.639 20.4507 20.4225 16.6673 20.4225 12C20.4225 7.33283 16.639 3.54931 11.9718 3.54931C7.5441 3.54931 3.91172 6.95446 3.55057 11.2888H16.0908V12.6961H3.54932C3.90326 17.0377 7.53893 20.4507 11.9718 20.4507Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBase24);
export default __webpack_public_path__ + "static/media/ic_base_24.0c073e0143c815b1c324a2246ed8550d.svg";
export { ForwardRef as ReactComponent };